import { PERMISSIONS } from "@how/permissions";

/**
 * Keys no support session may hold: users.manage could turn a session into a permanent membership, and
 * domains.manage_signin decides where a church's staff type their passwords (ADR 0067 P3, S9). The database refuses
 * both in request_support_session; the form does not offer them.
 */
export const NEVER_GRANTED: ReadonlySet<string> = new Set([
  "users.manage",
  "domains.manage_signin",
]);

/** The scope a session may be limited to: non-sensitive keys, and sensitive ones only for read and write. */
export function sessionPermissionOptions(
  accessLevel: "read_only" | "read_write",
): Array<{ value: string; label: string }> {
  return PERMISSIONS.filter(
    (p) => !NEVER_GRANTED.has(p.key) && (accessLevel === "read_write" || !p.isSensitive),
  ).map((p) => ({ value: p.key, label: `${p.key}${p.isSensitive ? " (sensitive)" : ""}` }));
}
